import { render, staticRenderFns } from "./BlocklyComponent.vue?vue&type=template&id=c852fbc4&scoped=true&"
import script from "./BlocklyComponent.vue?vue&type=script&lang=js&"
export * from "./BlocklyComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyComponent.vue?vue&type=style&index=0&id=c852fbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c852fbc4",
  null
  
)

export default component.exports